import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Resales from './resales';
import PageError from '../error/pageError';

export default class ResalesRoute extends React.Component {
    render() {
        const { path } = this.props;
        return (
            <Switch>
                {/* charts */}
                <Route exact path={`${path}`} render={basenameProps => <Resales organizationId={this.props.organizationId} history={basenameProps.history} />} />
                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${this.props.organization.id}`} />} />
            </Switch>
        );
    }
}

ResalesRoute.propTypes = {
    organizationId: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
};
